import React, { Fragment } from 'react';
import { InternalApiEntitySchemaField } from '../../../api-internal';
import { getDisplayName, orderBySchemaFields } from '../../../schema/helper';
import RmsPopover from '../../../common/popover/RmsPopover';
import ChildValue from './ChildValue';
import { Popover } from 'react-bootstrap';

interface Props {
  childAttributes: { [key: string]: string };
  childSchemaFields: InternalApiEntitySchemaField[] | undefined;
  schemaFields: InternalApiEntitySchemaField[] | undefined;
  fieldAccessor: {
    parentFieldName: string;
    attributeIndex: number;
  };
  highlightedFields?: string[];
}

const ObjectValuePreview = ({
  childAttributes,
  childSchemaFields,
  schemaFields,
  fieldAccessor,
  highlightedFields,
}: Props) => {
  const orderedFieldNames = orderBySchemaFields(childSchemaFields, Object.keys(childAttributes));

  const previewValues = orderedFieldNames
    .filter((fieldName) => childAttributes[fieldName] !== undefined && childAttributes[fieldName] !== null)
    .map((fieldName) => ({
      fieldName: fieldName,
      value: childAttributes[fieldName],
    }))
    .slice(0, 3);

  return (
    <RmsPopover
      key={fieldAccessor.attributeIndex}
      overlay={
        <Popover id='details-popover'>
          <table>
            <tbody>
              {orderedFieldNames
                .filter((fieldName) => childAttributes[fieldName] !== undefined)
                .map((childFieldName, i) => (
                  <tr key={i}>
                    <td className='keys'>
                      <span>
                        {getDisplayName(
                          childSchemaFields?.find((schemaField) => schemaField.fieldName === childFieldName)
                        ) || childFieldName}
                      </span>
                    </td>
                    <td className='values'>
                      <span>
                        <ChildValue
                          value={childAttributes[childFieldName]}
                          schemaFields={childSchemaFields}
                          fieldAccessor={{
                            ...fieldAccessor,
                            childFieldName,
                          }}
                          highlightedFields={highlightedFields}
                        />
                      </span>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </Popover>
      }
      placement={'bottom'}
    >
      <div className='popover-preview small'>
        {previewValues.map((preview, i) => (
          <Fragment key={i}>
            <ChildValue
              value={preview.value}
              schemaFields={schemaFields}
              fieldAccessor={{
                ...fieldAccessor,
                childFieldName: preview.fieldName,
              }}
              highlightedFields={highlightedFields}
            />
            <>{i < previewValues.length - 1 ? ' • ' : ''}</>
          </Fragment>
        ))}
      </div>
    </RmsPopover>
  );
};

export default ObjectValuePreview;
